import './header.css';

import { useNavigate, Link, useParams } from 'react-router-dom';

import Button from '../ui/button/Button';
import ThemeToggle from '../ui/themeToggle/ThemeToggle';
import logOut from '../../utils/logout';
import useNotes from '../../hooks/useNotes';
import useFolders from '../../hooks/useFolders';
import useTaskLists from '../../hooks/useTaskLists';
import { deleteNoteRequest } from '../../utils/deleteNoteRequest';
import { deleteFolderRequest } from '../../utils/deleteFolderRequest';
import { deleteTaskListRequest } from '../../utils/deleteTaskListRequest';

export default function Header({ userData }) {
  const { data: notes } = useNotes();
  const { data: folders } = useFolders();
  const { data: taskLists } = useTaskLists();

  function clearData(notes, folders, taskLists) {
    if (notes.length > 0 && notes !== undefined) {
      notes.map(note => {
        deleteNoteRequest(note.id);
      });
    }
    if (folders.length > 0 && folders !== undefined) {
      folders.map(folder => {
        deleteFolderRequest(folder.id);
      });
    }

    if (taskLists.length > 0 && taskLists !== undefined) {
      taskLists.map(taskList => {
        deleteTaskListRequest(taskList.id);
      });
    }
  }

  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <header className="header">
      <div className="container header-container">
        <Link
          className="header-logo"
          to={`/profile/${userData.id}`}
          width="70px"
        >
          <img src="/smallLogo.svg#smallLogo" alt="logo" width="70px" />
        </Link>

        <div className="user-container">
          <p
            onClick={e => {
              e.currentTarget.classList.toggle('isOpen');
            }}
            className="user-name"
          >
            {userData.username}
          </p>
          <div className="userDropdown">
            <Button
              className="userDropdownItem"
              onClick={() => {
                navigate(`/profile/${id}/settings`);
              }}
            >
              Налаштування
            </Button>
            <Button
              className="userDropdownItem"
              onClick={() => {
                if (id === '7b5cc38f-9eee-4a38-bde4-0cc21802bd66') {
                  clearData(notes, folders, taskLists);
                }
                logOut(navigate);
              }}
            >
              Вийти
            </Button>
          </div>
        </div>
        <ThemeToggle />
      </div>
    </header>
  );
}
